module.exports = __webpack_public_path__ + "img/gun-eris.815c62e7.jpg";